import { DOCUMENT, inject, Injectable, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class RootAttributeService {
  private readonly renderer2 = inject(Renderer2);
  private readonly document = inject(DOCUMENT);

  initBodyVersion(): void {
    this.renderer2.setAttribute(this.document.body, 'app-version', environment.version);
  }
}
